import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'

import type { FC, ReactNode } from 'react'

interface CreateConnectionDialogProps {
	open: boolean
	onOpenChange: (open: boolean) => void
	items: Array<{ name: string; icon: ReactNode; onClick?: () => void; secondaryText?: ReactNode }>
}

export const CreateConnectionDialog: FC<CreateConnectionDialogProps> = ({
	open,
	onOpenChange,
	items,
}) => {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-[525px]">
				<DialogHeader>
					<DialogTitle>Add a new connection</DialogTitle>
					<DialogDescription>Select an app to connect to your workspace.</DialogDescription>
				</DialogHeader>
				<div className="flex flex-col space-y-4">
					<Input id="search" placeholder="Search for an app" type="search" />
					<div className="flex flex-col space-y-1">
						{items.map((item) => (
							<button
								key={item.name}
								onClick={() => {
									item.onClick?.()
									onOpenChange(false)
								}}
								className="flex items-center p-2 -mx-2 rounded-md hover:bg-muted text-left cursor-pointer"
							>
								<div className="mr-2 *:flex-shrink-0 w-8 h-8 flex items-center justify-center">
									{item.icon}
								</div>
								<div className="flex flex-col">
									<span className="font-medium">{item.name}</span>
									{item.secondaryText && (
										<span className="text-sm text-muted-foreground">{item.secondaryText}</span>
									)}
								</div>
							</button>
						))}
					</div>
				</div>
			</DialogContent>
		</Dialog>
	)
}
